var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rr-inner"},[_c('div',{staticClass:"title"},[_vm._v("退款单变更记录")]),_c('div',{staticClass:"list"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(item.gmtCreate))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.description))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }